import * as React from 'react';
import { observer, inject } from 'mobx-react';
import LoggedinUser from '../../models/LoggedinUser';
import SurfAmountDonutChart from '../../components/surfamountdonutchart/SurfAmountDonutChart';
import SubscriptionDropDown from '../../components/subscriptiondropdown/SubscriptionDropDown';
import * as Spinner from 'react-spinkit';
import { getNoBrand } from '../../index';

//css
const subscrOvwStyle = require('./subscriptionoverview.css');


// Props
interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class SubscriptionOverview extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  render() {

    // images:
    // background image
    //const branding = 'tellit';
    const noBrand = getNoBrand();
    const branding = noBrand ? ('nobrand') : (this.props.loggedinUser.branding.brandingName);
    const imgOverviewBG = require('../../images/branding/' + branding + '/overview_bg.jpg');

    //grid images
    const imgCalls = require('../../images/callDarkBlue32x32.png');
    const imgSMS = require('../../images/messageDarkBlue32x32.png');
    const imgMMS = require('../../images/messageDarkBlue32x32.png');
    const imgSurf = require('../../images/wwwDarkBlue32x32.png');

    // We need to check that we have subscriptions
    if (this.props.loggedinUser.subscriptions.items.length === 0) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              {this.props.loggedinUser.isLoading &&
                <div className="subscr_progressdiv">
                  <Spinner name="ball-clip-rotate" fadeIn="full" className="subscr_spinner" />
                </div>
              }
              <div className="subscription_dropdown">
                <SubscriptionDropDown subscriptionList={this.props.loggedinUser.subscriptions} />
              </div>
            </div>
          </div>

          <br />
          <div className="subscr_ovw-imgdiv">
            <div>
              <img src={imgOverviewBG} className="ovw-img" alt="Abonnemang" />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container">

          <div className="row">
            <div className="col-xs-12">
              <div className="subscription_dropdown">
                <SubscriptionDropDown subscriptionList={this.props.loggedinUser.subscriptions} />
              </div>
            </div>
          </div>

          <br />
          <div className="subscr_ovw-imgdiv">
            <div>
              <img src={imgOverviewBG} className="ovw-img" alt="Abonnemang" />
            </div>
            {/* <h6 className="lowerleft textwhite">{this.props.loggedinUser.properties.mobilenumber}</h6> */}
            <h6 className="lowerleft textwhite">{this.props.loggedinUser.subscriptions.selectedSubscription.number}</h6>
            <h6 className="upperleft textwhite">Översikt</h6>

            <div className="pie-div">
              <SurfAmountDonutChart subscriptionList={this.props.loggedinUser.subscriptions} />
            </div>
          </div>

          <div className="badge_and_subscrperiod">
            {/* <Badge
            badgeContent={<IconButton tooltip="Här skriver vi en passande text om att värdena nedan kanske inte är helt up-to-date."><Schedule /></IconButton>}
            badgeStyle={{ fontSize: 20, top: 17, right: -3 }}
            className="badge"
          >
          </Badge> */}
            <h6 className="subscr_ovw_subscrperiod">Registrerat för perioden {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.period}</h6>
            <h6 className="subscr_data_update">Data uppdateras minst en gång per dygn.</h6>
          </div>


          {/* the grid with all icons and text about the account */}
          <div className="subscr_ovw_grid">
            <div className="subscr_ovw_calls_box" onClick={e => {
              e.preventDefault();
              this.props.loggedinUser.view.openBalancesPage();
              return false;
            }}
            >
              <img src={imgCalls} />
              <h6>Ringt inrikes</h6>
              {/* <h6>00:17:02</h6> */}
              <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.nationalCallTime}</h6>
            </div>
            <div className="subscr_ovw_SMS_box" onClick={e => {
              e.preventDefault();
              this.props.loggedinUser.view.openBalancesPage();
              return false;
            }}
            >
              <img src={imgSMS} />
              <h6>Skickade SMS</h6>
              {/* <h6>20 st</h6> */}
              <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.msgAmount.sentSMS} st</h6>
            </div>
            <div className="subscr_ovw_MMS_box" onClick={e => {
              e.preventDefault();
              this.props.loggedinUser.view.openBalancesPage();
              return false;
            }}
            >
              <img src={imgMMS} />
              <h6>Skickade MMS</h6>
              {/* <h6>20 st</h6> */}
              <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.msgAmount.sentMMS} st</h6>
            </div>
            <div className="subscr_ovw_surf_box" onClick={e => {
              e.preventDefault();
              this.props.loggedinUser.view.openBalancesPage();
              return false;
            }}
            >
              <img src={imgSurf} />
              <h6>Använd surf</h6>
              {/* <h6>4.1 GB</h6> */}
              <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.surfAmount.usedDataOneDecimalString} GB</h6>
            </div>
            {/* <div className="subscr_ovw_payservices_box">
            <div className="payServices_headline">Betaltjänster</div>
            <h6>samtal ? st</h6>
            <h6>samtalskostnad ?</h6>
          </div>
          <div className="subscr_ovw_abroad_box">
            <div className="abroad_headline">Utomlands</div>
            <h6>samtal 3 st</h6>
            <h6>samtal {this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.madeInternationalCalls} st</h6>
            <h6>samtalstid 00:47:09</h6>
            <h6>{this.props.loggedinUser.subscriptions.selectedSubscription.callsAmount.internationalCallTime}</h6>
          </div> */}
          </div>
        </div>

      );
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/subscriptionoverview/SubscriptionOverview.tsx